import _ from 'lodash';
import React from 'react';
import USDatePicker from './USDatePicker';
import './DurationGroup.scss';

class DurationGroup extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (<div className='duration-wrapper'>

            <div className='min-date-control'>
                <div className='calendar-icon'><i className="fa fa-calendar" aria-hidden="true"></i></div>
                <div className='datepicker-container'>
                    <USDatePicker setWidgetFieldValue={(field, value) => this.props.onChange(field, value)}
                        widget={this.props.widget} field='minDate' />
                </div>
            </div>

            <div className='max-date-control'>
                <div className='calendar-icon'><i className="fa fa-calendar" aria-hidden="true"></i></div>
                <div className='datepicker-container'>
                    <USDatePicker setWidgetFieldValue={(field, value) => this.props.onChange(field, value)}
                        widget={this.props.widget} field='maxDate' />
                </div>
            </div>

        </div >);
    }
}

DurationGroup.propTypes = {
    widget: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func
}

export default DurationGroup;


/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/DurationGroup.jsx
 **/